import { ClientItemId } from 'owa-client-ids';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { action } from 'satcheljs';

/**
 * Action called when list of event forwardees is changed
 */
export default action('onForwardeesChanged', (id: ClientItemId, forwardees: AttendeeType[]) => ({
    id,
    forwardees,
}));
